import React, { type ReactNode } from 'react'
import { cn } from '../utils'

export const SectionHeader: React.FC<{ 
    title: string; 
    children?: ReactNode;
    className?: string;
}> = ({ title, children, className }) => (
    <div className={cn('flex items-center gap-2 mb-2.5 flex-wrap', className)}>
        <h2 className="text-[13px] font-[500] text-gray-800 dark:text-gray-200 tracking-[-0.2px]">{title}</h2>
        {children && <div className="flex items-center gap-1.5 ml-auto flex-wrap">{children}</div>}
    </div>
)